module.exports = __webpack_public_path__ + "img/InsuredBadge.b3936757.svg";